import { render, staticRenderFns } from "./modelWatchInfoRightThree.vue?vue&type=template&id=01a05545&scoped=true&"
import script from "./modelWatchInfoRightThree.vue?vue&type=script&lang=js&"
export * from "./modelWatchInfoRightThree.vue?vue&type=script&lang=js&"
import style0 from "./modelWatchInfoRightThree.vue?vue&type=style&index=0&id=01a05545&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a05545",
  null
  
)

export default component.exports